import React from 'react';
import { Select } from 'antd';

let lang = sessionStorage.getItem('lang') === null ? 'IT' : sessionStorage.getItem('lang');

function LangSelector() {
  const changeLang = (lang) => {
    sessionStorage.setItem('lang', lang);
    location.reload();
  };

  return (
    <Select
      defaultValue={lang}
      onChange={changeLang}
      options={[
        { value: 'EN', label: 'EN' },
        { value: 'IT', label: 'IT' }
      ]}
      aria-label="Scelta della lingua"
    />
  );
}

export const getLanguage = () => {
  return lang;
};

export default LangSelector;
